import { render, staticRenderFns } from "./CardCarouselItem.vue?vue&type=template&id=6268a4e0&scoped=true&"
import script from "./CardCarouselItem.vue?vue&type=script&lang=js&"
export * from "./CardCarouselItem.vue?vue&type=script&lang=js&"
import style0 from "./CardCarouselItem.vue?vue&type=style&index=0&id=6268a4e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6268a4e0",
  null
  
)

export default component.exports